import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetContacto = ()  => {
    const api = useApi();

    const mutate = async (param) => {
        const data  = await api.get(`/contactos/${param}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getContactoMutation: mutation.mutate,
    };
}